"use client";
import React from "react";
import { Drawer, Button, Empty } from "antd";
import { Trash2, Heart } from "lucide-react";
import { useWishStore } from "context/wishStore";
import base from "lib/base";
import styles from "styles/components/wish-drawer.module.css";
import Link from "next/link";
import { useAuthContext } from "context/authContext";

const WishDrawer = () => {
  const { items, isOpen, setIsOpen, removeFromWishlist } = useWishStore();
  const { user } = useAuthContext();

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleRemove = (id) => {
    removeFromWishlist(id, user);
  };

  const resolveImage = (book) => {
    const raw = book?.cover || book?.images?.[0] || book?.image;
    if (!raw) return "/media/app/book_placeholder.png";
    if (/^https?:\/\//i.test(raw)) return raw;
    return `${base.cdnUrl}/${raw}`;
  };

  return (
    <Drawer
      title="Миний хүсэлтийн жагсаалт"
      placement="right"
      onClose={handleClose}
      open={isOpen}
      width={360}
      className={styles.wishDrawer}
      styles={{ body: { padding: 0 } }}
    >
      <div className={styles.container}>
        {items.length === 0 ? (
          <div className={styles.emptyState}>
            <Empty description="Хүсэлтийн жагсаалт хоосон байна" />
            <Button type="primary" onClick={handleClose} className="mt-4">
              Ном хайх
            </Button>
          </div>
        ) : (
          <div className={styles.itemsList}>
            {items.map((item) => {
              const book = item?.book || item;
              if (!book?._id) return null;
              const bookSlug = book?.slug ? `/books/${book.slug}` : "/books";
              const authorName =
                (Array.isArray(book.authors) && book.authors[0]
                  ? book.authors[0].nickname || book.authors[0].name
                  : null) ||
                (typeof book.author === "object"
                  ? book.author?.name
                  : book.author) ||
                "";

              const price = book?.price?.delivery?.price || 0;
              const discount = book?.price?.delivery?.discount || 0;
              const finalPrice = Math.max(0, price - discount);

              return (
                <div key={book._id} className={styles.wishItem}>
                  <div className={styles.itemImage}>
                    <img src={resolveImage(book)} alt={book.name} />
                  </div>
                  <div className={styles.itemDetails}>
                    <h4 className={styles.itemName}>
                      <Link href={bookSlug} onClick={handleClose}>
                        {book.name}
                      </Link>
                    </h4>
                    {authorName && (
                      <p className={styles.itemAuthor}>{authorName}</p>
                    )}
                    <div className={styles.priceRow}>
                      <span className={styles.price}>
                        {finalPrice.toLocaleString()}₮
                      </span>
                      {discount > 0 && (
                        <span className={styles.oldPrice}>
                          {price.toLocaleString()}₮
                        </span>
                      )}
                    </div>
                    <div className={styles.actionsRow}>
                      <span className={styles.wishTag}>
                        <Heart size={14} />
                        Wish
                      </span>
                      <button
                        className={styles.removeBtn}
                        onClick={() => handleRemove(book._id)}
                        aria-label="Remove from wishlist"
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default WishDrawer;
